module.exports = __webpack_public_path__ + "static/media/panda-face.25c8dc08.png";